import { NextRequest, NextResponse } from 'next/server'
import { and, eq, ilike, or, sql } from 'drizzle-orm'
import { db } from '@/db'
import { knowledgeEntries } from '@/db/schema'
import { requireExpertApiUser } from '@/lib/role-guard'
import { searchKnowledgeEntries } from '@/lib/knowledge-search'

export async function GET(request: NextRequest) {
  const guard = await requireExpertApiUser()
  if (!guard.ok) return guard.response

  const q = request.nextUrl.searchParams.get('q')?.trim() ?? ''
  if (q.length < 2) {
    return NextResponse.json({ results: [] })
  }

  const semanticResults = await searchKnowledgeEntries({
    tenantId: guard.user.tenantId,
    query: q,
    limit: 8,
  })

  if (semanticResults.length > 0) return NextResponse.json({ results: semanticResults })

  const fallbackResults = await db
    .select({
      id: knowledgeEntries.id,
      slug: knowledgeEntries.slug,
      title: knowledgeEntries.title,
      kind: knowledgeEntries.kind,
      bodyMarkdown: knowledgeEntries.bodyMarkdown,
      score: sql<number>`0`,
      updatedAt: knowledgeEntries.updatedAt,
    })
    .from(knowledgeEntries)
    .where(
      and(
        eq(knowledgeEntries.tenantId, guard.user.tenantId),
        eq(knowledgeEntries.isDeleted, false),
        or(ilike(knowledgeEntries.title, `%${q}%`), ilike(knowledgeEntries.bodyMarkdown, `%${q}%`)),
      ),
    )
    .limit(8)

  return NextResponse.json({ results: fallbackResults })
}
